import React, { useState, useCallback } from 'react'
import NumberFormat from 'react-number-format'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'

import TextInput from 'components/CommonUI/TextInput/TextInput'
import DropdownMenu, {
  DropdownMenuItem,
} from 'components/CommonUI/Dropdown/DropdownMenu'

import { countries } from 'constants/country-constants'

function mapFormattedPhone(value) {
  const coutries = Object.values(countries)

  let currentCountry = null
  let normalizedPhone = ''
  for (let i = 0; i < coutries.length; i++) {
    const country = coutries[i]
    const { mask } = country
    if (value.startsWith(mask)) {
      currentCountry = country
      normalizedPhone = value.replace(mask, '')
      break
    }
  }
  return {
    currentCountry,
    normalizedPhone,
  }
}

const useCommonStyle = makeStyles(() => {
  return {
    container: {
      width: '100%',
      position: 'relative',
      display: 'flex',
    },
    img: {
      marginRight: '10px',
      width: '20px',
      height: '14px',
    },
    choiseImg: {
      marginRight: '8px',
      width: '20px',
      height: '14px',
    },
    text: {
      fontSize: '16px',
      letterSpacing: '0.016em',
      color: '#151F31',
    },
    expandIcon: {
      fontSize: 14,
      transition: '0.2s',
    },
    input: {
      height: '49px',
      width: '175px',
      top: '23px',
      left: '-14px',
    },
    label: {
      position: 'absolute',
      // top: '-50%',
      left: 'unset',
      fontWeight: '600',
      fontSize: '14p',
      lineHeight: '18px',
      color: 'rgba(21, 31, 49, 0.8)',
    },
  }
})

const useStylesButton = makeStyles(() => {
  return {
    root: {
      backgroundColor: '#eaebed',
      height: '3.5em',
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      padding: '0 12px',
      borderRadius: '6px',
      bottom: '-4%',
    },
  }
})

function NumberFormatCustom(props) {
  const { value, onChange } = props

  return (
    <NumberFormat
      {...props}
      value={value}
      //name="phone"
      // label="Number"
      customInput={TextInput}
      type="text"
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.formattedValue.trim(),
          },
        })
      }}
    />
  )
}

const PhoneInputStyled = (props) => {
  const { value, onChange, name } = props
  const result = mapFormattedPhone(value)
  const { currentCountry, normalizedPhone } = result

  const [choiseCountry, setChoiseCountry] = useState(
    currentCountry || countries.us
  )

  const classesButton = useStylesButton()
  const classesCommon = useCommonStyle({ open: false })

  const handleClickMenuItem = useCallback(
    (values) => () => {
      setChoiseCountry(values)
    },
    []
  )

  return (
    <div className={classesCommon.container}>
      <DropdownMenu
        label="Number"
        controlComponent={({ onClick, active }) => (
          <Button className={classesButton.root} onClick={onClick}>
            <img
              src={choiseCountry.flagUrl}
              className={classesCommon.choiseImg}
              alt="country_flag"
            />
            <ExpandLessIcon
              className={classesCommon.expandIcon}
              style={{
                transform: active ? 'rotate(0deg)' : 'rotate(180deg)',
              }}
            />
          </Button>
        )}
      >
        {Object.entries(countries).map(([key, values]) => {
          return (
            <DropdownMenuItem key={key} onClick={handleClickMenuItem(values)}>
              <img
                src={values.flagUrl}
                className={classesCommon.img}
                alt="country_flag"
              />
              <span className={classesCommon.text}>{values.label}</span>
            </DropdownMenuItem>
          )
        })}
      </DropdownMenu>
      <NumberFormatCustom
        className={classesCommon.input}
        value={normalizedPhone}
        format={choiseCountry.telFormat}
        onChange={onChange}
        name={name}
        allowEmptyFormatting={choiseCountry.mask}
      />
    </div>
  )
}

export default PhoneInputStyled
